module.exports = __webpack_public_path__ + "media/assets/icons/minus-clock-cef5ab8aadf734411380e0ecd73303da.svg";